export enum AddressKind {
	HEADQUATERS = 'HQ',
	RESIDENCE = 'RSDN',
	CHECKINS = 'CHCK',
	SERVICE = 'SRVC',
	WORKSHOP = 'WSHP',
	OFFICE = 'OFFC',
}
